(async function init() {
    try {
        const data = await loadData();
        const normalizedData = normalize(data);

        STATE.accessories_step_id = Number('888888' + normalizedData.product_id);

        if (normalizedData.accessories) {
            const acc = normalizedData.accessories;

            const virtualStep = {
                id: STATE.accessories_step_id,
                title: acc.title,
                component_type: acc.component_type,
                groups: acc['0']?.components || [],
                products: []
            };

            normalizedData.components.push(virtualStep);
        }

        STATE.data = normalizedData;

        await renderAll();

        const steps = qsa(selFor(CLASSES.step), root);
        const firstVisible = steps.find(s => s.style.display !== 'none') || steps[0];

        /*** DEBUG ***/
        // if (firstVisible) window.beforeWccpStepTransition(firstVisible.dataset.item_id);
        // window.afterWccpStepDomRender();
        /*** END DEBUG ***/

        if (firstVisible) {
            await narrowIfNeededForStep(firstVisible);
            await ensureVariationsForStep(firstVisible);
        }
        if (firstVisible) updateStepNavButtons(firstVisible);
        if (firstVisible) prefetchFiltersForStep(firstVisible);


    } catch (e) {
        console.error(e);
        root.innerHTML = '<p style="color:#c00">Failed to initialize constructor.</p>';
    }

    window.WCCP_DEBUG = {
        computeAllowedByComponent,
        getMatchedScenarios,
        STATE,
        selectedVariants: () => ({ ...STATE.selectedVariants })
    };

    window.WCCP_DEBUG.probe = (cid) => {
        const set = (computeAllowedByComponent().get(Number(cid)) || new Set());
        return [...set];
    };

    window.WCCP_DEBUG.explain = function (cid) {
        const ms = getMatchedScenarios();
        const allowed = computeAllowedByComponent().get(Number(cid)) || new Set();
        return {
            matched_ids: ms.map(s => s.id),
            allowed: [...allowed]
        };
    };

    document.dispatchEvent(new CustomEvent('wccp:ready', { detail: { state: STATE } }));
})();